// shared/store/appSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AuthEnvironment } from 'shared/helpers/auth/detectAuthEnvironment';

export type AppState = {
  env: AuthEnvironment | null;
};

const initialState: AppState = { env: null };

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setEnv(state, action: PayloadAction<AuthEnvironment>) {
      state.env = action.payload;
    },
  },
});

export const { actions: appActions, reducer: appReducer } = appSlice;
